module.exports = __webpack_public_path__ + "static/media/breadbike_logo_final.a56f368b.png";